import { render } from "./editdiscount.vue?vue&type=template&id=768f8c30&scoped=true"
import script from "./editdiscount.vue?vue&type=script&lang=js"
export * from "./editdiscount.vue?vue&type=script&lang=js"

import "./editdiscount.vue?vue&type=style&index=0&id=768f8c30&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768f8c30"]])

export default __exports__